import { useIntl } from "react-intl";

import FormField from "components/molecules/FormField/FormField";

function UnitsField({ isRequired }: { isRequired: boolean }) {
  const intl = useIntl();
  return (
    <FormField
      label={intl.formatMessage({
        id: "new-request.packing-list.numberOfUnits",
        defaultMessage: "Quantity",
      })}
      type="textinput"
      placeholder={intl.formatMessage({
        id: "general.units",
        defaultMessage: "Units",
      })}
      field_id="units"
      validations={{
        validate: {
          onlyNumber: (v: any) => !isNaN(v) || "Please enter a valid number",
        },
        setValueAs: (v: string) => (!v ? null : v),
        shouldUnregister: true,
      }}
      mandatory={isRequired}
      containerClasses="w-100-px mr-2"
    />
  );
}

export default UnitsField;
